import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import { useUserSelector } from '~/hooks/useUserSelector';
import { routes } from '~/routes';
import ConfirmPopup from '../../../components/shared/ConfirmPopup';
import SelectWorkerType from '../../../images/SelectWorkerType.svg';
import { Colors } from '../../../themes/colors';

const POPUP_EXPIRATION_DATE = '2025-12-31';

export function SelectWorkerTypePopup() {
  const user = useUserSelector();
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();
  const isAddressInCalifornia = user?.address?.[0]?.state === 'CA';
  const isMissingWorkerClassification = !user?.workerClassification;
  const showPopupUntilDate = new Date(POPUP_EXPIRATION_DATE) > new Date();

  const getStorage = () => {
    const selectWorkerTypePopup = localStorage.getItem(`selectWorkerTypePopup-${user?.id}`);

    if (selectWorkerTypePopup === null) {
      setShowPopup(true);
    }
  };

  const setStorage = () => {
    localStorage.setItem(`selectWorkerTypePopup-${user?.id}`, 'false');
    setShowPopup(false);
  };

  const handleConfirm = () => {
    navigate(routes.workerClassificationType);
    setStorage();
  };

  useEffect(() => {
    getStorage();
  }, [user]);

  return (
    showPopup &&
    isAddressInCalifornia &&
    isMissingWorkerClassification &&
    showPopupUntilDate && (
      <ConfirmPopup
        Icon={() => (
          <img
            alt="SelectWorkerType"
            src={SelectWorkerType}
            style={{ width: 224, height: 158, marginBottom: 24 }}
          />
        )}
        title="Select a Worker Type!"
        description={
          <div
            style={{
              textAlign: 'left',
            }}
          >
            Before you can continue posting new shifts on GoTu, you will need to select a worker
            type for your office.
            <br />
            <br />
            <span>What does this mean for your existing shifts?</span>
            <ul
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: 8,
              }}
            >
              <li>
                Any unfilled shifts were removed and will need to be reposted after a worker type is
                selected.
              </li>
            </ul>
            <span>Click “Learn More” for more information on your options.</span>
          </div>
        }
        descriptionStyle={{ color: Colors.neutral_500, marginBottom: 32, width: 455 }}
        rightButtonText="Learn More"
        rightButtonAction={handleConfirm}
      />
    )
  );
}
